import React, { useEffect, useState } from "react";

import Button from "../components/button";
import Checkbox from "../components/checkbox";
import { Description, Link, RowContainer, ConsentLanguage } from "../components/description";
import Dropdown from "../components/dropdown";
import Error from "../components/error";
import Footer from "../components/footer";
import Icon from "../components/icon";
import Label from "../components/label";

import { get_current_carrier_list } from "../api/api-requests";

function Coverage({ type, isSubmitInProgress, submitForm, goToNextStep, setFieldValue, ...props }) {
    const [currentCarrierList, setCurrentCarrierList] = useState([]);
    const [isSectionVisited, setIsSectionVisited] = useState(false);
    const [stateCoverageRow, setStateCoverageRow] = useState({});
    const [validZip, setValidZip] = useState(false);

    const [showCoverageLevelDescription, setShowCoverageLevelDescription] = useState(false);
    const [showBiDescription, setShowBiDescription] = useState(false);
    const [showPdDescription, setShowPdDescription] = useState(false);
    const [showPipDescription, setShowPipDescription] = useState(false);

    const [showInsured, setShowInsured] = useState(true);
    const [showCurrentCarrier, setShowCurrentCarrier] = useState(false);
    const [showCoverageLevels, setShowCoverageLevels] = useState(false);
    const [showCoverageOptions, setShowCoverageOptions] = useState(false);
    const [showDeductibles, setShowDeductibles] = useState(false);

    useEffect(() => {
        const sectionFinished = sessionStorage.getItem("rrQuizCoverageSectionVisited");
        if (sectionFinished && sectionFinished == "true") {
            setIsSectionVisited(true);
        } else {
            if (!props.values.state || props.values.state == "--") {
                setValidZip(false);
            } else {
                setValidZip(true);
                if (!props.values.currentlyInsured) {
                    setShowInsured(true);
                } else if (props.values.currentlyInsured === "true" && !props.values.currentCarrier) {
                    setShowInsured(false);
                    setShowCurrentCarrier(true);
                } else if (!props.values.policy.coverageLevel) {
                    setShowInsured(false);
                    setShowCurrentCarrier(false);
                    setShowCoverageLevels(true);
                } else if (
                    props.values.policy.coverageLevel === "Custom" &&
                    (!props.values.policy.bi || !props.values.policy.pd || !props.values.policy.pil)
                ) {
                    setShowInsured(false);
                    setShowCurrentCarrier(false);
                    setShowCoverageLevels(false);
                    setShowCoverageOptions(true);
                } else {
                    // if (!props.values.policy.collision || !props.values.policy.comprehensive)
                    setShowInsured(false);
                    setShowCurrentCarrier(false);
                    setShowCoverageLevels(false);
                    setShowCoverageOptions(false);
                    setShowDeductibles(true);
                }
            }
        }
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        async function getCarrierList() {
            try {
                const { data } = await get_current_carrier_list();
                let temp = [];
                data.map((row) => temp.push({ label: row.carrier_name, value: row.carrier_name }));
                setCurrentCarrierList(temp);
            } catch (err) {
                console.log(err);
            }
        }

        getCarrierList();
    }, []);

    useEffect(() => {
        if (props.values.state && props.values.state != "--") {
            setValidZip(true);
            setStateCoverageRow(props.stateCoverages[props.values.state]);
        } else {
            setValidZip(false);
        }
    }, [props.stateCoverages, props.values.state]);

    function onPolicyCurrentInsuranceChange(value) {
        setFieldValue("currentlyInsured", value);
        setTimeout(() => {
            setShowInsured(false);
            if (value == "true") {
                setShowCurrentCarrier(true);
            } else {
                setShowCoverageLevels(true);
            }
        }, 200);
    }
    function onInsuredStatusNext() {
        props.setTouched({
            currentlyInsured: true,
        });
        props.validateForm().then((errors) => {
            if (props.values.currentlyInsured != "") {
                setShowInsured(false);
                if (props.values.currentlyInsured == "true") {
                    setShowCurrentCarrier(true);
                } else {
                    setShowCoverageLevels(true);
                }
            } else {
                console.log(errors);
            }
        });
    }

    function onCarrierSelectBack() {
        setShowCurrentCarrier(false);
        setShowInsured(true);
    }
    function onCarrierSelectNext() {
        props.setTouched({
            currentCarrier: true,
        });
        props.validateForm().then((errors) => {
            if (props.values.currentCarrier != "") {
                setShowCurrentCarrier(false);
                setShowCoverageLevels(true);
            } else {
                console.log(errors);
            }
        });
    }

    function onCoverageLevelChange(value) {
        setFieldValue("policy.coverageLevel", value);
        switch (value) {
            case "Minimum":
                setFieldValue("policy.bi", stateCoverageRow.minimum_bi);
                setFieldValue("policy.pd", stateCoverageRow.minimum_pd);
                setFieldValue("policy.pil", stateCoverageRow.minimum_pip);
                setFieldValue("policy.collision", stateCoverageRow.minimum_coll);
                setFieldValue("policy.comprehensive", stateCoverageRow.minimum_comp);
                break;
            case "Standard":
                setFieldValue("policy.bi", stateCoverageRow.standard_bi);
                setFieldValue("policy.pd", stateCoverageRow.standard_pd);
                setFieldValue("policy.pil", stateCoverageRow.standard_pip);
                setFieldValue("policy.collision", stateCoverageRow.standard_coll);
                setFieldValue("policy.comprehensive", stateCoverageRow.standard_comp);
                break;
            case "Premium":
                setFieldValue("policy.bi", stateCoverageRow.premium_bi);
                setFieldValue("policy.pd", stateCoverageRow.premium_pd);
                setFieldValue("policy.pil", stateCoverageRow.premium_pip);
                setFieldValue("policy.collision", stateCoverageRow.premium_coll);
                setFieldValue("policy.comprehensive", stateCoverageRow.premium_comp);
                break;
            case "Custom":
                setFieldValue("policy.bi", "");
                setFieldValue("policy.pd", "");
                setFieldValue("policy.pil", "");
                setFieldValue("policy.collision", "");
                setFieldValue("policy.comprehensive", "");
                break;
        }
        setTimeout(() => {
            setShowCoverageLevels(false);
            if (value != "Custom") {
                props.setIsCoverageSectionCompleted(true);
                sessionStorage.setItem("rrQuizCoverageSectionVisited", "true");
                setShowDeductibles(true);
            } else {
                setShowCoverageOptions(true);
            }
        }, 200);
    }
    function onCoverageLevelBack() {
        setShowCoverageLevels(false);
        if (props.values.currentlyInsured == "false") {
            setShowInsured(true);
        } else {
            setShowCurrentCarrier(true);
        }
    }
    function onCoverageLevelNext() {
        props.setTouched({
            policy: {
                coverageLevel: true,
            },
        });
        props.validateForm().then((errors) => {
            if (props.values.policy && props.values.policy.coverageLevel != "") {
                setShowCoverageLevels(false);
                if (props.values.policy.coverageLevel != "Custom") {
                    setShowDeductibles(true);
                } else {
                    setShowCoverageOptions(true);
                }
            } else {
                console.log(errors);
            }
        });
    }

    function onCoverageOptionBack() {
        setShowCoverageOptions(false);
        setShowCoverageLevels(true);
    }
    function onCoverageOptionNext() {
        props.setTouched({
            policy: {
                bi: true,
                pd: true,
                pil: true,
            },
        });
        props.validateForm().then((errors) => {
            if (props.values.policy.bi != "" && props.values.policy.pd != "" && props.values.policy.pil != "") {
                setShowCoverageOptions(false);
                props.setIsCoverageSectionCompleted(true);
                sessionStorage.setItem("rrQuizCoverageSectionVisited", "true");
                setShowDeductibles(true);
            } else {
                console.log(errors);
            }
        });
    }

    function onDeductibleBack() {
        setShowDeductibles(false);
        if (props.values.policy.coverageLevel != "Custom") {
            setShowCoverageLevels(true);
        } else {
            setShowCoverageOptions(true);
        }
    }

    function getRates() {
        setFieldValue("queryType", type);
        props.setErrorSubmitting(false);
        props.setTouched({
            bundleInsurance: true,
            currentlyInsured: true,
            currentCarrier: true,
            policy: {
                bi: true,
                pd: true,
                pil: true,
                coverageLevel: true,
                collision: true,
                comprehensive: true,
            },
        });
        props.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                const newItems = [...props.steps];
                let currentStepIndex = newItems.findIndex((row) => row.key === "COVERAGE");
                let step = newItems[currentStepIndex];
                step.isVisited = "true";
                step.isDisabled = "false";
                newItems[currentStepIndex] = step;
                props.setSteps(newItems);

                props.setProgressPercentage(100);
                document.getElementById("finley-spinner-search") && document.getElementById("finley-spinner-search").classList.add("show");
                props.setIsSubmitInProgress(true);
                props.setIsCoverageSectionCompleted(true);
                sessionStorage.setItem("rrQuizCoverageSectionVisited", "true");
                submitForm();
            } else {
                console.log(errors);
            }
        });
    }
    function coverageContinueClick() {
        props.setTouched({
            currentlyInsured: true,
            currentCarrier: true,
            policy: {
                bi: true,
                pd: true,
                pil: true,
                coverageLevel: true,
                collision: true,
                comprehensive: true,
            },
        });
        props.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                const newItems = [...props.steps];
                let currentStepIndex = newItems.findIndex((row) => row.key === "COVERAGE");
                let step = newItems[currentStepIndex];
                step.isVisited = "true";
                step.isDisabled = "false";
                newItems[currentStepIndex] = step;
                // Next step
                if (newItems[currentStepIndex + 1]) {
                    step = newItems[currentStepIndex + 1];
                    step.isDisabled = "false";
                    newItems[currentStepIndex + 1] = step;
                }
                props.setSteps(newItems);

                props.setProgressPercentage(75);
                props.setIsCoverageSectionCompleted(true);
                sessionStorage.setItem("rrQuizCoverageSectionVisited", "true");
                goToNextStep("PROPERTY", true);
            } else {
                console.log(errors);
            }
        });
    }

    return (
        <React.Fragment>
            {!validZip && <Error text="Zip code error. Please re-enter your zip code in the Driver section to continue with coverages." />}

            {validZip && (isSectionVisited || showInsured) && (
                <React.Fragment>
                    <Label text="Are you currently insured?"></Label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <Checkbox
                            label="Yes"
                            checked={props.values.currentlyInsured === "true"}
                            onClick={() => {
                                onPolicyCurrentInsuranceChange("true");
                            }}
                            style={{ marginRight: "1rem", width: "100%" }}
                        />
                        <Checkbox
                            label="No"
                            checked={props.values.currentlyInsured === "false"}
                            onClick={() => {
                                onPolicyCurrentInsuranceChange("false");
                            }}
                            style={{ width: "100%" }}
                        />
                    </div>
                    {props.touched && props.touched.currentlyInsured && props.errors && props.errors.currentlyInsured && (
                        <Error text={props.errors.currentlyInsured} />
                    )}
                    {!isSectionVisited && <Footer showBack={false} forwardClick={() => onInsuredStatusNext()} />}
                </React.Fragment>
            )}

            {validZip && (isSectionVisited || showCurrentCarrier) && props.values.currentlyInsured === "true" && (
                <React.Fragment>
                    <Label text="Who is your current insurance provider?"></Label>
                    <Dropdown
                        placeholder="Please select"
                        name="currentCarrier"
                        onChange={(value) => {
                            setFieldValue("currentCarrier", value);
                        }}
                        options={currentCarrierList}
                        error={`${props.touched && props.touched.currentCarrier && props.errors && props.errors.currentCarrier}`}
                        marginBottom="1rem"
                    />
                    {!isSectionVisited && <Footer backClick={() => onCarrierSelectBack()} forwardClick={() => onCarrierSelectNext()} />}
                </React.Fragment>
            )}

            {validZip && (isSectionVisited || showCoverageLevels) && (
                <React.Fragment>
                    <Label text="How much coverage do you need?"></Label>
                    <Checkbox
                        label="Premium"
                        showtag="true"
                        sublabel={stateCoverageRow.premium}
                        checked={props.values.policy.coverageLevel === "Premium"}
                        onClick={() => {
                            onCoverageLevelChange("Premium");
                        }}
                        style={{ height: "65px" }}
                    />
                    <Checkbox
                        label="Standard"
                        sublabel={stateCoverageRow.standard}
                        checked={props.values.policy.coverageLevel === "Standard"}
                        onClick={() => {
                            onCoverageLevelChange("Standard");
                        }}
                        style={{ height: "65px" }}
                    />
                    <Checkbox
                        label="State Minimum"
                        sublabel="Minimum coverage"
                        checked={props.values.policy.coverageLevel === "Minimum"}
                        onClick={() => {
                            onCoverageLevelChange("Minimum");
                        }}
                        style={{ height: "65px" }}
                    />
                    <Checkbox
                        label="Custom"
                        checked={props.values.policy.coverageLevel === "Custom"}
                        onClick={() => {
                            onCoverageLevelChange("Custom");
                        }}
                        style={{ height: "65px" }}
                    />
                    {props.touched &&
                        props.touched.policy &&
                        props.touched.policy.coverageLevel &&
                        props.errors &&
                        props.errors.policy &&
                        props.errors.policy.coverageLevel && <Error text={props.errors.policy.coverageLevel} />}
                    {!isSectionVisited && <Footer backClick={() => onCoverageLevelBack()} forwardClick={() => onCoverageLevelNext()} />}
                    <Description>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}>
                            <Icon viewBox="0 0 256 256" icon="info" size={20} stroke="#004ECC" color="#004ECC" />
                            <span
                                onClick={() => setShowCoverageLevelDescription(!showCoverageLevelDescription)}
                                style={{ textDecoration: "underline" }}
                            >
                                Not sure? View the coverage details here.
                            </span>
                        </div>
                        {showCoverageLevelDescription && (
                            <ul>
                                <li>
                                    <span className="heading">Premium limits: </span>
                                    {`your insurance will cover up to ${stateCoverageRow.premium.split("/")[0]}/person or ${
                                        stateCoverageRow.premium.split("/")[1]
                                    }/accident for bodily injury to others, and up to ${stateCoverageRow.premium.split("/")[2]} for property damage in an accident you cause.
									Recommended because it significantly improves your coverage without significantly increasing your premium cost.`}
                                </li>
                                <li>
                                    <span className="heading">Standard limits: </span>
                                    {`your insurance will cover up to ${stateCoverageRow.standard.split("/")[0]}/person or ${
                                        stateCoverageRow.standard.split("/")[1]
                                    }/accident for bodily injury to others, and up to ${stateCoverageRow.standard.split("/")[2]} for property damage in an accident you cause.`}
                                </li>
                                <li>
                                    <span className="heading">State Minimum: </span>
                                    these are the lowest limits allowed in your state. This covers legal requirements, but also provides the least
                                    amount of coverage.
                                </li>
                                <li>
                                    <span className="heading">Custom: </span>
                                    should only be used if you're confident in choosing the right amount of insurance you need.
                                </li>
                            </ul>
                        )}
                    </Description>
                </React.Fragment>
            )}

            {validZip && (isSectionVisited || showCoverageOptions) && props.values.policy.coverageLevel === "Custom" && (
                <React.Fragment>
                    <Label text="Bodily Injury (BI)"></Label>
                    <Dropdown
                        placeholder="Select amount"
                        name="policy.bi"
                        value="policy.bi"
                        onChange={(value) => {
                            setFieldValue("policy.bi", value);
                        }}
                        options={stateCoverageRow.custom_bi}
                        error={`${props.touched && props.touched.policy && props.touched.policy.bi && props.errors && props.errors.policy && props.errors.policy.bi}`}
                    />
                    <Description>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}>
                            <Icon viewBox="0 0 256 256" icon="info" size={20} stroke="#004ECC" color="#004ECC" />
                            <span onClick={() => setShowBiDescription(!showBiDescription)} style={{ textDecoration: "underline" }}>
                                Bodily Injury explained.
                            </span>
                        </div>
                        {showBiDescription && (
                            <ul>
                                Liability insurance that covers costs associated with the other party’s injuries in an accident you caused. The first
                                number is the limit per person in the accident; the second number is the limit for the entire accident.
                            </ul>
                        )}
                    </Description>

                    <Label text="Property Damage (PD)"></Label>
                    <Dropdown
                        placeholder="Select amount"
                        name="policy.pd"
                        value="policy.pd"
                        onChange={(value) => {
                            setFieldValue("policy.pd", value);
                        }}
                        options={stateCoverageRow.custom_pd}
                        error={`${props.touched && props.touched.policy && props.touched.policy.pd && props.errors && props.errors.policy && props.errors.policy.pd}`}
                    />
                    <Description>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}>
                            <Icon viewBox="0 0 256 256" icon="info" size={20} stroke="#004ECC" color="#004ECC" />
                            <span onClick={() => setShowPdDescription(!showPdDescription)} style={{ textDecoration: "underline" }}>
                                Property Damage explained.
                            </span>
                        </div>
                        {showPdDescription && (
                            <ul>
                                Liability insurance that covers costs associated with damages to the other party’s vehicle in an accident you caused.
                            </ul>
                        )}
                    </Description>

                    <Label text="Personal Injury Protection (PIP)"></Label>
                    <Dropdown
                        placeholder="Select amount"
                        name="policy.pil"
                        value="policy.pil"
                        onChange={(value) => {
                            setFieldValue("policy.pil", value);
                        }}
                        options={stateCoverageRow.custom_pip}
                        error={`${props.touched && props.touched.policy && props.touched.policy.pil && props.errors && props.errors.policy && props.errors.policy.pil}`}
                    />
                    <Description>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}>
                            <Icon viewBox="0 0 256 256" icon="info" size={20} stroke="#004ECC" color="#004ECC" />
                            <span onClick={() => setShowPipDescription(!showPipDescription)} style={{ textDecoration: "underline" }}>
                                Personal Injury Protection explained.
                            </span>
                        </div>
                        {showPipDescription && <ul>Covers costs associated with injuries that you or your passengers incur during an accident.</ul>}
                    </Description>

                    {!isSectionVisited && <Footer backClick={() => onCoverageOptionBack()} forwardClick={() => onCoverageOptionNext()} />}
                </React.Fragment>
            )}

            {validZip && (isSectionVisited || showDeductibles) && (
                <React.Fragment>
                    <Description>
                        <ul>
                            <li>
                                <span className="heading">Collision: </span>
                                covers damage to your own vehicle in an accident or collision.
                            </li>
                            <li>
                                <span className="heading">Comprehensive: </span>
                                covers damage to your vehicle in case of theft, weather, etc.
                            </li>
                            <li>
                                <span className="heading">Deductible: </span>
                                the amount you pay before your insurance covers the rest of a claim.
                            </li>
                        </ul>
                    </Description>

                    <Label text="Select deductible for collision:"></Label>
                    <Dropdown
                        placeholder="Select amount"
                        name="policy.collision"
                        value="policy.collision"
                        onChange={(value) => {
                            setFieldValue("policy.collision", value);
                        }}
                        options={stateCoverageRow.custom_coll}
                        error={`${props.touched && props.touched.policy && props.touched.policy.collision && props.errors && props.errors.policy && props.errors.policy.collision}`}
                    />
                    <Label text="Select deductible for comprehensive:"></Label>
                    <Dropdown
                        placeholder="Select amount"
                        name="policy.comprehensive"
                        value="policy.comprehensive"
                        onChange={(value) => {
                            setFieldValue("policy.comprehensive", value);
                        }}
                        options={stateCoverageRow.custom_comp}
                        error={`${props.touched && props.touched.policy && props.touched.policy.comprehensive && props.errors && props.errors.policy && props.errors.policy.comprehensive}`}
                    />

                    {/* {type != "HOME" && props.values.bundleInsurance === "true" && ( */}
                    {type == "BUNDLE" && (
                        <RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
                            {!isSectionVisited && (
                                <Link>
                                    <div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onDeductibleBack()}>
                                        Previous
                                    </div>
                                </Link>
                            )}
                            <Button onClick={coverageContinueClick} text="Next step" />
                        </RowContainer>
                    )}
                    {/* {(type == "HOME" || props.values.bundleInsurance === "false") && ( */}
                    {type != "BUNDLE" && (
                        <>
                            <RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
                                {!isSectionVisited && (
                                    <Link>
                                        <div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onDeductibleBack()}>
                                            Previous
                                        </div>
                                    </Link>
                                )}
                                <Button onClick={getRates} text="Get My Rates" isLoading={isSubmitInProgress} />
                            </RowContainer>
                            {props.errorSubmitting && <Error text="A few required fields are missing" />}
                            <ConsentLanguage>
                                By clicking 'Get My Rates', you give us permission to share the info you've given us with{" "}
                                <a href="/our-partners-auto-quiz" target="_blank" style={{ textDecoration: "underline", color: "blue" }}>
                                    our partners
                                </a>{" "}
                                to get you more accurate rate estimates. Rate Retriever will not store or resell your personal information.
                            </ConsentLanguage>
                        </>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default Coverage;
